// extracted by mini-css-extract-plugin
export default {"section":"VideoSection_section__g0CJl","video":"VideoSection_video__WaPB2"};